import { useEffect, useRef } from 'react';

export function ScrollToAnchor() {
	const location = window.location;
	const lastHash = useRef('');

	useEffect(() => {
		if (location.hash) {
			lastHash.current = location.hash.slice(1);
		}

		setTimeout(() => {
			if (lastHash.current && document.getElementById(lastHash.current)) {
				setTimeout(() => {
					document.getElementById(lastHash.current)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
					lastHash.current = '';
				}, 100);
			}
		}, 100);
	}, [location]);

	return null;
}
